import React from 'react';

import styles from './CreateRecipesModal.css';

class LoadingSpinner extends React.Component {
  render() {
    const { showLoadingSpinner } = this.props;
    return (
      showLoadingSpinner && (
        <div className={styles.spinner}>
          <div className={styles['loading-spinner']} />
          <div className={styles['loading-text']}>
            <p> Importing 1 file </p>
            <p> Please wait this might take a little while </p>
          </div>
        </div>
      )
    );
  }
}

LoadingSpinner.defaultProps = {
  showLoadingSpinner: false,
};

LoadingSpinner.propTypes = {
  showLoadingSpinner: React.PropTypes.bool,
};

export default LoadingSpinner;
